import { MyOrder, VisibleColumnSpec } from "@/types";

export const SNAPSHOT_ORDER_COLUMNS: VisibleColumnSpec<MyOrder, "actions" | "icon" | "product" | "lastPrice">[] = [
  "icon",
  "created",
  { id: "salesItem", breakpoint: "mantine-visible-from-xl" },
  "product",
  { id: "amount", breakpoint: "mantine-visible-from-sm" },
  { id: "remainingAmount", breakpoint: "mantine-visible-from-lg" },
  { id: "finalAmount", breakpoint: "mantine-visible-from-md" },
  "status",
  { id: "lastPrice", breakpoint: "mantine-visible-from-lg" },
  { id: "fullLoad", breakpoint: "mantine-visible-from-lg" },
  // { id: "orderCurrency", breakpoint: "mantine-visible-from-lg" },
  // Replace <CURRENCY> with the runtime currency (e.g. `totalPriceWithFee.EUR`)
  "actions",
];
